import { render, staticRenderFns } from "./UrlTemplate.vue?vue&type=template&id=5c5c01f0&scoped=true&"
import script from "./UrlTemplate.vue?vue&type=script&lang=js&"
export * from "./UrlTemplate.vue?vue&type=script&lang=js&"
import style0 from "./UrlTemplate.vue?vue&type=style&index=0&id=5c5c01f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5c01f0",
  null
  
)

export default component.exports